import React, { useState, useContext, useEffect } from 'react';
import { Modal } from 'react-bootstrap';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { 
  FaLocationDot, 
 } from 'react-icons/fa6'; 
import { Button } from '@/shared/components/Button';
import AddEditMeal from '../AddEditMeal';
import { Mealcontext } from '../../../../../context/MealContext';
import { PermissionContext } from '../../../../../context/PermissionContext';
import { GlobalVarContext } from '../../../../../context/GlobalVarContext';
import { AuthContext } from '../../../../../context/AuthContext';





const RejectedRequestCard = ({
  id,
  mealName,
  resName,
  remark,
  photo,
  // setRefresh,
}) => {
     const [showEditModel, setShowEditModel] = useState(false);
     const [MealId, setMealId] = useState(id);
     const [restaurantSelectoption, setRestaurantSelectOption] = useState(null);
     const { permissionsAccess } = useContext(PermissionContext);
     const { meals, setMeals, setRefresh } = useContext(Mealcontext);
     const { apiGlobal } = useContext(GlobalVarContext);
     const { restaurantid, userid } = useContext(AuthContext);

  const hideEditModal = () => {
    setShowEditModel(false);
    setMeals([]);
  };

  

   // Edit Meal Data Handler
   const EditMealData = async (values) => {
    // console.log(selectedid);
    const formattedValues = {
      items: meals,
  };
   

    const utcStartDate = values.start_date;
    const utcEndDate = values.end_date;

 

    // Convert to IST
    const startDate = new Date(utcStartDate);
    const endDate = new Date(utcEndDate);

    // IST offset is +5:30
   const istOffset = 5.5 * 60 * 60 * 1000;
   const startDateIST = new Date(startDate.getTime() + istOffset);
   const endDateIST = new Date(endDate.getTime() + istOffset); 
   
   const formatDate = date => `${date.getFullYear()}-${String(date.getMonth() + 1)
    .padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;

const formattedStartDate = formatDate(startDateIST);
const formattedEndDate = formatDate(endDateIST);

    const mealOffered = [];

    if (values.breakfast) {
        mealOffered.push('1');
    }
    if (values.Snacks) {
        mealOffered.push('2');
    }
    if (values.lunch) {
        mealOffered.push('3');
    }
    if (values.dinner) {
        mealOffered.push('4');
    }

    const location = [];
    

    if (values.locationsid && Array.isArray(values.locationsid)) {
      values.locationsid.forEach((locationItem) => {
        if (locationItem?.value) {
          location.push(locationItem.value); 
        }
      });
    } else if (values.locations && Array.isArray(values.locations)) {
      values.locations.forEach((locationItem) => {
        if (locationItem?.location_id) {
          location.push(locationItem.location_id); 
        }
      });
    }

    if (location.length === 0) {
      toast.error('location not selected....');
      return;
    }
   
    

    const formData = new FormData();
    formData.append('id', values.id);
    formData.append('name', values.name); 
    formData.append('restaurant_id', restaurantid);
    formData.append('location_ids', location.join(','));  
    formData.append('price', values.price); 
    formData.append('foc', values.foc); 
    formData.append('foc_on', values.foc_on); 
    formData.append('meal_type', values.meal_type); 
    formData.append('discription', values.description); 
    formData.append('photo', values.logo); 
    formData.append('start_date', formattedStartDate); 
    formData.append('end_date', formattedEndDate); 
    formData.append('markup_percentage', values.markup_percentage);
    formData.append('cuisine', values.cuisines); 
    formData.append('defaultMarkup', values.markup_percentage); 
    formData.append('meal_offered', mealOffered.join(',')); 
    formData.append('meal_format', values.format); 
    formData.append('veg_non_veg', values.veg); 
    formData.append('type', 1); 

    formData.append('change_type', 1);
    formData.append('user_id', userid);
    
    if (Array.isArray(formattedValues.items)) {
      formData.append('items', JSON.stringify(formattedValues)); 
  } else {
      console.error('Items format is invalid');
  }

    try {
      // setLoading(true);
      const response = await fetch(`${apiGlobal}/meal_edit.php`, {
          method: 'POST',
          body: formData,
      });
      if (!response.ok) {
          console.log(`Network response was not ok: ${response.statusText}`);
      }
      const responseData = await response.json();
      if (responseData.status && responseData.message === 'Data updated successfully.') {
          toast.success('Meal Edit Successfully...');
          setShowEditModel(false);
          setRefresh(prev => !prev);
          setMeals([]);
          // refreshHandler();
      } else {
          toast.error(responseData.message);
      }
  } catch (error) {
      toast.error(error.message);
  } finally {
    // setLoading(false);
    }
  };
  
  

  return (
    <div 
      className="card mb-3 position-relative" 
      style={{
        maxWidth: '100%',
        border: '2px solid',
        borderRadius: '12px',
        boxShadow: '0 8px 16px rgba(0, 0, 0, 0.15)',
        overflow: 'hidden',
        transition: 'transform 0.3s ease',
          // backgroundColor: currentTheme === 'Dark' ? '#232329' : 'white',
          // color: currentTheme === 'Dark' ? 'white' : 'black',
        }}
      onMouseEnter={(e) => {
        e.currentTarget.style.transform = 'scale(1.02)';
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.transform = 'scale(1)';
      }}
      
    >

      <div className="row g-0">
        <div className="col-md-12">
          <div className="remark mt-2">
            <i>
              Remark : <span style={{ color: 'red' }}>{remark}</span>
            </i> 
          </div>
          <hr />
        </div>
        <div className="col-md-4 col-12">
          <div className="card-body">
            <h3 className="card-title">
              Meal Name : {mealName}

            </h3>
            <p className="card-text"><FaLocationDot />
              Restaurant Name : {resName}
            </p>
          </div>
        </div>
               
      </div>
      {permissionsAccess?.[2]?.master_id === '3'
          && permissionsAccess?.[2]?.edit === 1 && (
            <Button 
              variant="outline-danger"
              title="Edit Info"
              className="w-[12%] align-self-end"
              size="sm"
              style={{
              marginRight: '10px',
            }}
              onClick={() => setShowEditModel(true)}
            >
              Edit Meal 
            </Button>    
          )}
      

      
      <Modal show={showEditModel} onHide={hideEditModal} size="xl">
        <Modal.Header 
      //     style={{
      //    backgroundColor: currentTheme === 'Dark' && '#232329',
      //    color: currentTheme === 'Dark' && '#fff',
      //  }}
          closeButton
          // closeVariant={currentTheme === 'Dark' && 'white'}
          
        >
          
          <Modal.Title>Edit Meal</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <AddEditMeal 
            onSubmit={EditMealData} 
            id={id} 
            setRestaurantSelectOption={setRestaurantSelectOption}
          />
        </Modal.Body>
      </Modal>

      
      

    </div>
  );
}; 

RejectedRequestCard.propTypes = {
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  mealName: PropTypes.string.isRequired,
    
    remark: PropTypes.string.isRequired,
    resName: PropTypes.string.isRequired,
    photo: PropTypes.string.isRequired,
    // setRefresh: PropTypes.func.isRequired,
    

};



export default RejectedRequestCard;
